import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { GMLiveConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { GradeMatrixLiveService } from './api/gradeMatrixLive.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class GMLiveApiModule {
    public static forRoot(configurationFactory: () => GMLiveConfiguration): ModuleWithProviders<GMLiveApiModule> {
        return {
            ngModule: GMLiveApiModule,
            providers: [ { provide: GMLiveConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: GMLiveApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('GMLiveApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
